(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('warning-dashboard', {
                parent: 'dashboard',
                url: '/warning?fleet&objectType',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.warning.dashboard.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/dashboards/warning-dashboard/warning-dashboard.html',
                        controller: 'WarningDashboardController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    fleet: {
                        value: '-1',
                        squash: true
                    },
                    objectType: {
                        value: '-1',
                        squash: true
                    },
                    filterElastic: {
                        value: {status: 'open'},
                        squash: true
                    }
                },

                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            fleet: $stateParams.fleet,
                            objectType: $stateParams.objectType,
                            filterElastic: $stateParams.filterElastic
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('warning');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('warning-dashboard-detail', {
                parent: 'entity',
                url: '/warning/{frame}?fleetId&objectType&objectUniqueCode&warningCategory&warningName&detail',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabObjects.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/dashboards/warning-dashboard/warning-dashboard-detail.html',
                        controller: 'WarningDashboardDetailController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    frame: null,
                    titlePage: null,
                    detail: null,

                    fleetId: null,
                    objectType: null,
                    objectUniqueCode: null,
                    warningCategory: null,
                    warningName: null
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('warning');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    detail: ['$stateParams', function ($stateParams) {
                        return $stateParams.detail;
                    }],
                    frame: ['$stateParams', function ($stateParams) {
                        return $stateParams.frame;
                    }],
                    titlePage: ['$stateParams', function ($stateParams) {
                        return $stateParams.titlePage;
                    }],
                    fleetId: ['$stateParams', function ($stateParams) {
                        return $stateParams.fleetId;
                    }],
                    objectType: ['$stateParams', function ($stateParams) {
                        return $stateParams.objectType;
                    }],
                    objectUniqueCode: ['$stateParams', function ($stateParams) {
                        return $stateParams.objectUniqueCode;
                    }],
                    warningCategory: ['$stateParams', function ($stateParams) {
                        return $stateParams.warningCategory;
                    }],
                    warningName: ['$stateParams', function ($stateParams) {
                        return $stateParams.warningName;
                    }]
                }
            });
    }
})();
